import { compose, propEq, find } from 'ramda'

export const getUpgradePopupProfileTitle = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_PROFILE_TITLE'))
)
